import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Search } from "lucide-react";
import { DURATION_UNITS } from "@/lib/durations";

export default function SearchBar({ variant = "hero" }) {
  const navigate = useNavigate();
  const [lake, setLake] = useState("any");
  const [duration, setDuration] = useState("any");
  const [q, setQ] = useState("");
  const [lakes, setLakes] = useState([]);

  useEffect(() => {
    api.get("/lakes").then((r) => setLakes(r.data.lakes)).catch(() => {});
  }, []);

  const submit = (e) => {
    e?.preventDefault();
    const params = new URLSearchParams();
    if (lake && lake !== "any") params.set("lake", lake);
    if (duration && duration !== "any") params.set("duration", duration);
    if (q) params.set("q", q);
    navigate(`/search?${params.toString()}`);
  };

  const isHero = variant === "hero";

  return (
    <form
      onSubmit={submit}
      data-testid="search-bar"
      className={`flex flex-col md:flex-row items-stretch gap-2 rounded-2xl border border-border ${isHero ? "bg-white/85 backdrop-blur-xl shadow-lg" : "bg-card"} p-2`}
    >
      <div className="flex-1 flex flex-col justify-center px-4 py-2 border-b md:border-b-0 md:border-r border-border">
        <label className="text-[10px] uppercase tracking-widest text-muted-foreground">Waterway</label>
        <Select value={lake} onValueChange={setLake}>
          <SelectTrigger data-testid="search-lake-select" className="border-0 shadow-none p-0 h-auto text-base focus:ring-0">
            <SelectValue placeholder="Any waterway" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="any">Any waterway</SelectItem>
            {lakes.map((l) => (
              <SelectItem key={l} value={l} data-testid={`lake-option-${l}`}>{l}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="flex-1 flex flex-col justify-center px-4 py-2 border-b md:border-b-0 md:border-r border-border">
        <label className="text-[10px] uppercase tracking-widest text-muted-foreground">Rent by</label>
        <Select value={duration} onValueChange={setDuration}>
          <SelectTrigger data-testid="search-duration-select" className="border-0 shadow-none p-0 h-auto text-base focus:ring-0">
            <SelectValue placeholder="Any duration" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="any">Any duration</SelectItem>
            {DURATION_UNITS.map((d) => (
              <SelectItem key={d.unit} value={d.unit} data-testid={`duration-option-${d.unit}`}>
                {d.labelSingular.charAt(0).toUpperCase() + d.labelSingular.slice(1)}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div className="flex-1 flex flex-col justify-center px-4 py-2">
        <label className="text-[10px] uppercase tracking-widest text-muted-foreground">City or ZIP</label>
        <Input
          data-testid="search-query-input"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="e.g. Cornelius or 28031"
          className="border-0 shadow-none p-0 h-auto text-base focus-visible:ring-0"
        />
      </div>
      <Button data-testid="search-submit-btn" type="submit" size="lg" className="rounded-xl bg-accent hover:bg-accent/90 text-accent-foreground gap-2 px-6">
        <Search className="h-4 w-4" strokeWidth={2}/> Search
      </Button>
    </form>
  );
}
